<template>
  <div class="addGoodsWrapper">
      <Loading> </Loading>
      <el-dialog
		:title="$t('other.a261')"
		:visible.sync="formulaDia"
        :close-on-click-modal="false"
		width="50%"
		>
        <div>
            <p class="tips">{{$t('other.a262')}}</p>
            <p class="tips">{{$t('other.a263')}}</p>
            <p class="tips">{{$t('other.a264')}} </p>
        </div>
        <div style="margin-top:10px;text-align:right;">
            <el-button size="mini" type="primary" @click="addNewFormula()">{{$t('other.a265')}}</el-button>
        </div>
		<div style="margin-top:8px;">
            <el-table
                :data="formulaList"
                size="mini"
                border
               >
                <el-table-column :label="$t('other.a30')" >
                    <template slot-scope="props">
                       <span >{{$t('other.a266')}}{{props.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a267')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.outboundfee}}</span>
                       <el-input size="mini" v-show="props.row.checked" v-model="props.row.outboundfee" placeholder=""></el-input>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a268')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.rate}}</span>
                       <el-input size="mini" v-show="props.row.checked" v-model="props.row.rate" placeholder=""></el-input>
                    </template>
                </el-table-column>
                 <el-table-column :label="$t('other.a269')" >
                    <template slot-scope="props">
                       <span >{{props.row.country}}</span>
                       
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a270')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.profit}}</span>
                       <el-input style="width:80px" size="mini" v-show="props.row.checked" v-model="props.row.profit" placeholder=""></el-input>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a271')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.discount}} off</span>
                       <el-input style="width:80px" size="mini" v-show="props.row.checked" v-model="props.row.discount" placeholder=""></el-input>
                    </template>
                </el-table-column>
                <el-table-column  :label="$t('other.a33')" width="280px">
                    <template slot-scope="props" >
                       <span style="margin:0 2px"><el-button size="mini" :type="!props.row.default ? 'primary': 'danger'" @click="setDefault(props.row,props.$index)">{{$t('other.a272')}}</el-button></span>
                       <span style="margin:0 2px" v-show="!props.row.checked"><el-button size="mini" type="primary" @click="props.row.checked=true">{{$t('other.a93')}}</el-button></span>
                       <span style="margin:0 2px" v-show="!props.row.checked"><el-button size="mini" type="primary" @click="updateRule(props.row,props.$index,0)">{{$t('other.a273')}}</el-button></span>
                       <span style="margin:0 2px" v-show="props.row.checked"><el-button size="mini" type="warning" @click="updateRule(props.row,props.$index,1)">{{$t('other.a274')}}</el-button></span>
                       <span style="margin:0 2px" v-show="props.row.checked"><el-button size="mini" type="info" @click="props.row.checked=false">{{$t('other.a106')}}</el-button></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="formulaDia = false">{{$t('other.a5')}}</el-button>
		</span>
		</el-dialog>
      <el-dialog
		:title="$t('other.a275')"
		:visible.sync="replaceImg"
		width="30%">
		<div style="text-align: center">
           <el-input v-model="shopeeUrl" :placeholder="$t('other.a276')"></el-input>
		</div>
        <div style="margin-top:20px" v-if="showPersoun">
            <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
        </div>
        <div style="margin-top:20px" v-if="showPersoun">
            <span v-if="percentage !== 100"><i class="el-icon-loading"></i>{{$t('other.a277')}}</span>
            <span v-if="percentage == 100">{{$t('other.a278')}}</span>
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="replaceImg = false">{{$t('other.a5')}}</el-button>
			<el-button type="primary" @click="getOnlineProduct()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>
        <el-dialog
		:title="$t('other.a280')"
        :close-on-click-modal="false"
		:visible.sync="updatPic"
		width="30%"
		>
		<div style="text-align: center">
            <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :headers="token"
            :http-request="handleUploadHttpRequest"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">{{$t('other.a281')}}</div>
            </el-upload>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="updatPic = false,imageUrl=null,imageId=null">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="imgConfirm()">{{$t('other.a279')}}</el-button>
		</span>
	  </el-dialog>
      
      <div class="center">
          <div class="mainContent">

            <div class="lefttips">
                <div class="sigk">
                    <div class="jgind">{{$t('other.a282')}}</div>
                    <div class="kloi">{{$t('other.a283')}}</div>
                    <div class="kloi">{{$t('other.a284')}}</div>
                </div>
            </div>
            <div class="right_content">
                <div class="desctext" >{{$t('other.a285')}}-{{publishType}}</div>
                <div class="categoryDesc">
                    <span class="categoryname"  v-for="(item,index) in dataParams.categoryname" :key="index">{{item}}<span class="inkg">/</span></span>
                    <span class="categoryname" style="cursor: pointer" @click="reflash()">{{$t('other.a286')}}</span>
                </div>
                <div style="margin-top:10px;">
                    {{$t('other.a2604')}}：
                    <el-select size="mini" @change="chooseItem()" v-model="itemId" :placeholder="$t('other.a50')">
                        <el-option
                        v-for="item in onlineOptions"
                        :key="item.itemId"
                        :label="$t('other.a2605')+ item.itemId"
                        :value="item.itemId">
                        </el-option>
                    </el-select>
                </div>
                <div class="baseInfo">
                    <div class="title">{{$t('other.a287')}}</div>
                    <div class="leftTesc">
                        <div class="inrk"><span  class="ikrn"></span>{{$t('other.a288')}}</div>
                        <div>{{dataParams.shopName}}</div>
                    </div>
                    <div class="leftTesc">
                        <div class="inrk"><span  class="ikrn"></span>{{$t('other.a289')}}</div>
                        <div >
                            <div style="border-bottom:1px solid #eee;padding-bottom:3px;">
                                <el-button size="mini" type="primary" @click="randomNum()">{{$t('other.a290')}}</el-button>
                                <el-button size="mini" type="primary" @click="editorwaterMakr()">{{$t('other.a291')}}</el-button>
                                <el-button size="mini" type="primary" @click="replaceImg=true">{{$t('other.a292')}}</el-button>
                            </div>
                            <div style="font-size:12px;padding-top:10px;" @click="logImg()">{{$t('other.a293')}}</div>
                            <div style="display:flex;">
                                

                                <draggable
                                style="display:flex;"
                                v-model="modelData.images"
                                tag='ul'
                                v-bind="dragOptions"
                                @change="logImg()"
                                @start="modelData.drag = true"
                                @end="modelData.drag = false"
                                >
                                <div class="imgBox" @mouseenter="activeIndex=index" @mouseleave="activeIndex=-1" v-for="(item,index ) in modelData.images" :key="index">
                                <img style="width:100%" :src="item.image" />
                                <span v-show="activeIndex == index"  class="delBox">
                                    <div class="ingk">
                                        <i class="el-icon-edit" @click="editorImg(item.image,index)"></i>
                                        <i class="el-icon-delete" @click="modelData.images.splice(index,1)"></i>
                                    </div>
                                </span>
                                </div>
                                
                                </draggable>


                                <el-upload
                                v-if="modelData.images.length < 8"
                                action="https://erp.shopsbu.com/service/access/upload"
                                :headers="token"
                                :on-success="handlePreview"
                                multiple
                                :limit="8"
                                :on-exceed="handleExceed"
                                >
                                    <div class="imgBox">
                                        <div class="pomjg">
                                        <i class="el-icon-picture-outline"></i>
                                        <div style="font-size:12px;">{{$t('other.a294')}}</div>
                                        </div>
                                    </div>
                                </el-upload>
                            
                            </div>
                            
                        </div>
                    </div>
                    <div class="leftTesc">
                        <div class="inrk"><span  class="ikrn"></span>{{$t('other.a295')}}</div>
                        <div class="iyubn">
                            <el-input style="width:973px;" size="mini" v-model="modelData.name" placeholder=""></el-input>
                            <div v-if="modelData.name.length > 120" style="color:red;font-size:12px;">{{$t('other.a296')}}</div>
                            <span class="ingknv">{{modelData.name.length}}/120</span>
                        </div>
                    </div>

                    <div class="leftTesc" v-if="publishType !== 'TikTok Shop'">
                        <div class="inrk"><span  class="ikrn"></span>{{$t('other.a297')}}</div>
                        <!-- lazada属性显示 -->
                        <div class="ilnrg" v-if="publishType == 'lazada'">
                            <div class="ogong" v-if="attrName.indexOf(item.name) == -1"  v-for="(item,index) in normal" :key="index">
                                <div class="olik" ><span v-show="item.isMandatory" class="ikrn"></span>{{item.name}}</div>
                                <div>
                                    <el-select v-if="item.inputType == 'singleSelect' || item.inputType == 'multiSelect'" class="ogong" size="mini" v-model="item.value" placeholder="">
                                        <el-option
                                            v-for="item in item.options"
                                            :key="item.name"
                                            :label="item.name"
                                            :value="item.name">
                                        </el-option>
                                    </el-select>
                                    <el-input size="mini" v-if="item.inputType == 'numeric' || item.inputType == 'text' || item.inputType == 'enumInput' || item.inputType == 'multiEnumInput'" v-model="item.value" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>
                        <!-- tiktop属性显示 -->
                        <!-- <div class="ilnrg" v-if="publishType == 'TikTok Shop'">
                            <div class="ogong" v-if="attrName.indexOf(item.name) == -1"  v-for="(item,index) in tiktokAttribute" :key="index">
                                <div class="olik" ><span v-show="item.input_type.is_mandatory" class="ikrn"></span>{{item.name}}</div>
                                <div>
                                    
                                    <el-input size="mini" 
                                    v-if="item.input_type.is_customized" 
                                    v-model="item.value" placeholder="">
                                    </el-input>
                                </div>
                            </div>
                        </div> -->
                        <!-- shopee属性显示 -->
                        <div class="ilnrg" v-if="publishType == 'shopee'">
                            <div class="ogong"   v-for="(item,index) in shopeeAttribute" :key="index">
                                <div class="olik" ><span v-show="item.is_mandatory" class="ikrn"></span>{{item.attribute_name}}</div>
                                <div>
                                    <el-select filterable 
                                    v-el_selectLoadmore:addRangeNumber="loadMore()"
                                    v-if="item.input_type == 'DROP_DOWN' 
                                    || item.input_type == 'COMBO_BOX'"   
                                    class="ogong" size="mini" 
                                    v-model="item.value" placeholder="">
                                        <el-option
                                            v-for="item in item.values.slice(0,rangeNumber)"
                                            :key="item.original_value"
                                            :label="item.original_value"
                                            :value="item.original_value">
                                        </el-option>
                                    </el-select>
                                    <el-input  
                                    size="mini"
                                    v-if="item.input_type == 'TEXT_FILED' " 
                                    v-model="item.value" 
                                    :placeholder="$t('other.a298')" >
                                    </el-input>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="baseInfo">
                    <div class="title">{{$t('other.a299')}}</div>
                    <div class='bugkn'>
                        <span v-if="valuation">{{$t('other.a300')}}+{{valuation.outboundfee}}￥）/{{valuation.rate}}({{$t('other.a268')}})*{{valuation.profit/100+1}}{{$t('other.a301')}}/{{1-valuation.discount/100}}{{$t('other.a302')}}</span>
                        <el-button size="mini" type="primary" @click="formulaDia=true">{{$t('other.a303')}}</el-button>
                    </div>
                    

                    <!-- <div class="leftTesc">
                        <div class="inrk"><span class="ikrn"></span>{{$t('other.a334')}}</div>
                        <div class="ilnrg ppol" >
                            <div v-for="(sku,index) in isSaleProp" :key="index">
                                <div class="qbrt"><span class="ikrn"></span>{{$t('other.a335')}}{{index+1}}</div>
                                <div class="qbrt"><span >{{sku.name}}</span></div>
                                <div class="qbrt">
                                    <div>
                                        <div><input type="text" v-model="text"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="leftTesc">
                        <div class="inrk">{{$t('other.a304')}}</div>
                        <div>
                            <div class="ilnrg ppol">
                                <div style="padding:5px 10px;display:flex;">
                                    <div><el-input style="width:200px;margin-right:10px;" size="mini" v-model="fontValue" :placeholder="$t('other.a305')"></el-input></div>
                                    <div><el-button size="mini" type="info" @click="massDelSamefont()">{{$t('other.a38')}}</el-button></div>
                                </div>
                            </div>
                        </div>
                        
                        
                    </div>

                    <div class="leftTesc">
                        <!-- <div>
                            <el-button size="mini" type="primary">{{$t('other.a303')}}</el-button>
                        </div> -->
                        <div class="inrk"><span class="ikrn"></span>{{$t('other.a306')}}</div>
                        
                        <div class="ilnrg ppol">
                            <div class="yhgt">
                                <span class="yjbg"><el-input size="mini" style="width:150px" v-model="sellerSKU" placeholder="sellerSku"></el-input></span>
                                <span class="yjbg"><el-input size="mini" style="width:150px" v-model="priceValue" placeholder="price"></el-input></span>
                                <span class="yjbg"><el-input size="mini" style="width:150px" v-model="stock" placeholder="stock"></el-input></span>
                                <span class="yjbg"><el-button size="mini" style="width:150px" @click="massSetVariation()" type="info">{{$t('other.a307')}}</el-button></span>
                            </div>
                            <div style="width:100%;" class="yhjv">
                                <el-table size="mini" border :data="modelData.variations" style="width: 100%">
                                <el-table-column prop="date" :label="$t('other.a217')" width="60">
                                    <template slot-scope="props">
                                        <el-popover v-if="props.row.image" ref="popover1" placement="right" trigger="hover"
                                            >
                                            <img style="width:200px;height:200px;" :src="props.row.image" alt="">
                                            <div slot="reference">
                                                <div  class="ImgPox" @click="changePic(props.row,1)">
                                                <img :src="props.row.image" alt="">
                                                </div>
                                            </div>
                                        </el-popover>
                                        <div v-else class="attImg"  @click="changePic(props.row,1)">
                                            
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="publishType == 'lazada'"  prop="date" label="sellerSKU" >
                                    <template slot-scope="props">
                                        <el-input size="mini" v-model="props.row.variationSku" placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                                
                                <el-table-column v-if="publishType == 'shopee'"  prop="date" label="sku" >
                                    <template slot-scope="props">
                                        <div><el-input size="mini" v-model="props.row.variationSku" placeholder=""></el-input></div>
                                        <div style="color:red;text-align:right;padding-right:5px;" v-if="props.row.variationSku.length >= 20">{{$t('other.a308')}}</div>

                                    </template>
                                </el-table-column>

                                <el-table-column :v-if="item.type == 'tiktok' && tiktokAttributeList.length > 0"  v-for="(item,index) in tiktokAttributeList" :key="index"   :label="item.name" >
                                    <template slot-scope="props">
                                        <el-input v-if="index == 0" size="mini" v-model="props.row.variationSku" placeholder=""></el-input>
                                        <el-input v-if="index == 1" size="mini" v-model="props.row.value" placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="publishType == 'TikTok Shop' && tiktokAttributeList.length == 0"   label="sku">
                                    <template slot-scope="props">
                                        <div><el-input size="mini" v-model="props.row.variationSku" placeholder=""></el-input></div>
                                        <div style="color:red;text-align:right;padding-right:5px;" v-if="props.row.variationSku.length >= 20">{{$t('other.a308')}}</div>
                                    </template>
                                </el-table-column>


                                <el-table-column prop="date" :label="$t('other.a309')" >
                                    <template slot-scope="props">
                                        <el-input  size="mini" 
                                        v-model="props.row.price"
                                        @blur="props.row.price=Number(props.row.price)" 
                                        :placeholder="$t('other.a309')"></el-input>
                                        <!-- <span class="supplice"><span class="gong">供:￥ {{props.row.supplyPrice}} </span></span> -->
                                    </template>
                                </el-table-column>
                                
                                <el-table-column prop="date" :label="$t('other.a310')" width="90">
                                    <template slot-scope="props">
                                        <el-input size="mini" v-model="props.row.stock" placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="date" :label="$t('other.a311')" width="180" >
                                    <template slot-scope="props">
                                        {{props.row.cusCode}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="date" :label="$t('other.a33')"  >
                                    <template slot-scope="props">
                                       <span @click="deleteItem(props.$index)">{{$t('other.a312')}}</span>
                                    </template>
                                </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>

                    <div class="leftTesc">
                        <div class="inrk"><span  class="ikrn"></span>{{$t('other.a313')}}</div>
                        <div class="ilnrg ppol" >
                            <div style="width:100%;">
                                <div class="yhjv">
                                    <div class="refd"><span  class="ikrn"></span>{{$t('other.a314')}}
                                        <el-input style="width:100px;" @blur="modelData.weight=Number(modelData.weight)" size="mini" v-model="modelData.weight" placeholder=""></el-input>
                                    </div>
                                    <div class="refd"><span  class="ikrn"></span>{{$t('other.a315')}}
                                        <el-input style="width:100px;" @blur="modelData.packageLength=Number(modelData.packageLength)" size="mini" v-model="modelData.packageLength" placeholder=""></el-input>
                                        X <el-input style="width:100px;" @blur="modelData.packageWidth=Number(modelData.packageWidth)" size="mini" v-model="modelData.packageWidth" placeholder=""></el-input>
                                        X <el-input style="width:100px;" @blur="modelData.packageHeight=Number(modelData.packageHeight)" size="mini" v-model="modelData.packageHeight" placeholder=""></el-input>
                                    </div>
                                    <div class="refd" v-if="publishType == 'shopee'"><span  class="ikrn"></span>{{$t('other.a316')}}
                                        <span style="margin-right:15px;" v-for="(item,index) in logistics" :key="index">
                                            <el-checkbox v-model="item.checked">{{item.logistics_channel_name}}</el-checkbox>
                                        </span>
                                    </div>
                                    <div class="refd" v-if="publishType == 'TikTok Shop'"><span  class="ikrn"></span>{{$t('other.a317')}}
                                        <span style="margin-right:15px;" v-for="(item,index) in tiktopStore" :key="index">
                                            <el-checkbox v-model="item.checked">{{item.warehouse_name}}</el-checkbox>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="leftTesc" v-if="publishType == 'shopee' || publishType =='TikTok Shop' ">
                        <div class="inrk"><span  class="ikrn"></span>{{$t('other.a318')}}</div>
                        <div class="ilnrg ppol" >
                            <div style="width:100%;">
                               <el-input
                                type="textarea"
                                :autosize="{ maxRows: 20}"
                                :placeholder="$t('other.a319')"
                                v-model="modelData.description">
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>


      <div class="footer">
            <el-button v-if="publishType == 'lazada'" type="primary" @click="publish()">{{$t('other.a320')}}</el-button>
            <el-button v-if="publishType == 'shopee'" type="primary" @click="publishShopee()">{{$t('other.a321')}}</el-button>
            <el-button v-if="publishType == 'TikTok Shop'" type="primary" @click="publishTikTok()">{{$t('other.a322')}}</el-button>
            
      </div>
  </div>
</template>

<script>
import Loading from '../../../components/loadingBase'
import lazadaordersApi from '../../../api/moudles/lazadaorders' 
import tiktokApi from '../../../api/moudles/tiktok'
import api from '../../../api/api'
import md5 from 'js-md5'
import utils from '../../../utils/utils'
import draggable from "vuedraggable"
import {WARNING_CODES, SHOPEE_PUBLISH_WARNING} from '../../../config/config'
import { resolve } from 'path'
import { rejects } from 'assert'
import { log } from 'util'
export default {
data(){
return{
    token:{
        token:JSON.parse(localStorage.getItem('userInfo')).token
    },
    dataParams:null,
    formulaDia:false,
    itemId:null,
    shopeeUrl:null,
    updatPic:false,
    showPersoun:false,
    warehouseId:null,
    fontValue:null,
    groupInfo:null,
    changeAttrPic:false,
    changePicObj:null,
    activeIndex:-1,
    rangeNumber:20,
    percentage:0,
    userId:null,
    text:null,
    normal:[],
    imageUrl:null,
            imageId:null,
    tiktokAttributeList:[],
    onlineOptions:[],
    model:null,
    tiktopStore:[],
    modelData:{
        tiers:[],
        images:[],
        name:''
    },
    attrName:[
        'name',
        'short_description',
        'description',
        'description_en',
    ],
    skuList:[],
    sellerSKU:null,
    priceValue:null,
    stock:null,
    isSaleProp:[],
    publishType:'shopee',
    shopeeAttribute:[],
    logistics:[],
    replaceImg:false,
    formulaList:[],
    valuation:{},
    tiktokAttribute:[],
    falg:false
}
},
computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

   
  },
components:{
    Loading,
    draggable
},
watch:{
    valuation(){
          if(this.valuation){
              console.log('okngl',this.valuation)
              let obj=JSON.parse(JSON.stringify(this.valuation))
              obj.outboundfee=Number(obj.outboundfee)
              obj.discount=Number(obj.discount)
              obj.rate=Number(obj.rate)
              obj.profitRate=Number(obj.profit)/100+1
                setTimeout(() => {
                    this.modelData.variations.forEach(p => {
                        p.supplyPrice=Number(p.supplyPrice)
                        p.retailPrice=(p.supplyPrice+obj.outboundfee)/obj.rate*obj.profitRate
                        p.retailPrice=p.retailPrice/(1-obj.discount/100)
                        p.retailPrice=p.retailPrice.toFixed(2)
                    })
                    console.log('okgjkgmb',this.modelData)
                },1000)

          }else{
              if(!this.$route.query.childrenProductId){
                  this.modelData.variations.forEach(p => {
                            p.retailPrice=null
                    })
              }
          }
      },
},
directives:{
    clickOutSide:{
        bind:function(el, binding , vnode){
            function documentHandler(e){
                if(el.contains(e.target)){
                return false
                }

                if(binding.expression){
                    binding.value(e)
                }
            }
            el._vueClickOutside_ =documentHandler
            document.addEventListener('click',documentHandler)
        },

        unbind:function (el,binding) {
            document.removeEventListener('click',el._vueClickOutside_)
        }

    },
    el_selectLoadmore:{
        bind(el,binding){
            let self=this
            const SELECTWRAP_DOM =el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
           
            SELECTWRAP_DOM.addEventListener('scroll', function () {
                const condition = this.scrollHeight - this.scrollTop-20 <= this.clientHeight
                if (condition) binding.value()
            })
        }
    }
},
activated(){
    if(this.$route.query.refreshType == 1){
        let images=JSON.parse(localStorage.getItem('warterImg'))
        this.modelData.images=images
    }

    if(this.$route.query.refreshType == 2){
        let obj=JSON.parse(localStorage.getItem('editorImg'))
        console.log('999',obj);
        this.modelData.images[obj.index].image=obj.url
        console.log(this.modelData.images);
    }
},
created(){
    this.publishType=this.$route.query.type
    let shops=JSON.parse(localStorage.getItem('userInfo'))
    this.userId=shops ? shops.userId : null
    this.dataParams=JSON.parse(localStorage.getItem('addLazada'))
    this.categoryId=this.dataParams.categoryId.filter(p => {
        if(p){
            return p
        }
    })

    utils.getInfoByCache({
        cacheKey:'onlineOptions',
        userId:this.userId
    }).then(res => {
        this.onlineOptions=res
        console.log('onlineOptions',this.onlineOptions)

    })
    
    // this.getGroupInfo()

    console.log('dataParams',this.dataParams)
},
methods:{

    chooseItem(){
        let params=this.onlineOptions.find(item => item.itemId == this.itemId)
        console.log('params',params)
        this.getOnlineProduct(params.country,params.itemId,params.shopId)
        
    },

    

    getOnlineProduct(country,itemId,shopId){

     api
     .getStoreItemByGroupId({
         groupId:this.$route.query.groupId
     })
     .then(res => {
     if(res.code === 200 ){
       this.putAway=res.data.putAway
       this.originItem=res.data
       this.originItem.putAway=true
       this.originItem.fixGrossProfitRate=null
       this.originItem.fixIssuePrice=null
       this.originItem.storeItems.forEach(p => {
         p.costCopy=null,
         p.costDesc=this.$t('other.a2495')+p.cost
         p.putAway=true
         if(p.proportion == 0.3){
           this.proportion=true
         }
       })
       console.log('originItem',this.originItem)



        let url=utils.getUrlByItemIDandCountry(country,itemId,shopId)
        
        let matchId="itemid=" +itemId+ '&' + "shopid=" + shopId
        let if_match_="55b03-" + md5.hex("55b03" + md5.hex(matchId) + "55b03")
        let host=url.slice(0,url.indexOf("?")+1)
        console.log('host',host)

        api
        .scrapedProdcutItem({
            ifMatchIn:if_match_,
            origin:host,
            url:url
        }).then(res => {
          console.log('shopee产品详情',res);
        let onlineData=res.data || res.item
        if(!onlineData){
            this.$message.warning(this.$t('other.a2570'))
            return
        }
        // res.item=res.data
        console.log('desc',res)
        let obj={
            attributes:[],
            productShops:[],
            categoryId:0,
            modelId:null,
            name: null,
            images:[],
            drag: false,
            status:'NORMAL',
            description:null,
            packageHeight:this.originItem.storeItems[0].packageHeight,
            packageLength:this.originItem.storeItems[0].packageLength,
            packageWidth:this.originItem.storeItems[0].packageWidth,
            country:'ROOT',
            weight:this.originItem.storeItems[0].weight,
            price:null,
            hasVariation:false,
            variations:[],
            variationsCopy:[],
            tiers:[],
            logistics:[],
            userId:this.userId
        }

        obj.description=onlineData.description
        obj.name=onlineData.name
        obj.sourceUrl=host+matchId
        obj.categoryId=onlineData.categories[onlineData.categories.length-1].catid

        obj.categoryName=onlineData.categories.map(p => {
          return p.display_name
        })

        obj.categoryName=obj.categoryName.join('/')

        
        

        onlineData.images.forEach((p,index) => {
            obj.images.push({
                image:utils.getImageUrl(country,p),
                positions:index,
                label:"image"+index
            })
        })
      
    
        

        onlineData.tier_variations.forEach((p,index) => {
            if(p.images){
                p.images=p.images.map(k => {
                    return utils.getImageUrl(country,k)
                })
            }
              
        })

        obj.tiers[0]={}
        obj.tiers[0].name=onlineData.tier_variations[0].name
        obj.tiers[0].images=[]
        obj.tiers[0].optionArray=[]

       

        obj.tiers[0].imagesUrl=JSON.stringify(obj.tiers[0].images)
        obj.tiers[0].options=JSON.stringify(obj.tiers[0].optionArray)
        obj.tiers[0].positions=0

        obj.variations=this.originItem.storeItems.map((k,index) => {
            return {
                cusCode:k.cusCode,
                price:null,
                stock:k.storeNum,
                tierIndex:[index],
                variationSku:k.skuName,
                productId:null,
                variationId:null,
                name:null,
                image:k.image

            }
        })

    

        this.modelData=obj

        this.getTikTokAttribute()
        this.getTikTokAttributeRule()
        this.getTikTokBrand()
        this.getTiktokWarehouse()

        console.log('modelData',this.modelData)
        console.log('onlineItem',this.onlineItem)

        
      
        })





     }else{
     this.$message.warning(res.msg)
     }
     })
        
    
    },

    reflash(){
        let ttp=this.$route.query.type
        let ccp=''
        if(ttp == 'TikTok Shop'){
            ccp='/publishTikTok'
        }else if(ttp == 'lazada'){
            ccp='/publishLazada'
        }else if(ttp == 'shopee'){
            ccp='/publishShopee'
        }
        console.log(ttp,ccp)
        this.$router.push({
            path:ccp,
            query:{
                id:this.$route.query.productId,
                groupId:this.$route.query.groupId,
            }
        })
        
    },

    getGroupInfo(){
        api
        .getStoreItemByGroupId({
            groupId:this.$route.query.groupId
        })
        .then(res => {
            if(res.code == 200){
                
                let list=res.data
                list.storeItems.forEach(p => {
                    // p.chl_cusCode=p.children[0].cusCode //暂时不知道用处但报错所以先隐藏
                })
                console.log('i',list)
                this.groupInfo=list
                this.getModelInfo()
            }
        })
    },
    getImg(){

        let imglist=[]
        this.modelData.variations.forEach(p => {
            let numIndex=p.image.indexOf('?')
            if(numIndex > -1){
                p.image=p.image.substr(0,numIndex)
            }

            imglist.push(p.image)

        })

        let params={
            imageUrls:imglist,
            sellerId:this.dataParams.shopId,
            userId:this.userId
        }
        console.log('params',params)
        lazadaordersApi
        .getLazadaImg(params)
        .then(res => {
        if(res.code === 200 ){
        let list=res.data.data.images
        console.log('list',list)
        list.forEach((i,index) => {
            this.modelData.variations[index].image=i.url
        })
        console.log('modelData',this.modelData)
        this.publish()

        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    //上架TIKTOK时转换图片
    getTiktokImg(params){
        return new Promise((resolve,rejects) => {
            tiktokApi
            .getTikTokImage(params)
            .then(res => {

            // resolve({
            //     id:res.data ? res.data.img_id : 0
            // })
            if(res.code === 200 ){
            if(!res.data){
                this.$message.error(this.$t("other.a323"))
                this.hideLoadingbase()
                return
            }
            console.log('desc',res.data)
            resolve({
                id:res.data.img_id
            })
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
        
    },

    getTiktokWarehouse(){
        tiktokApi
        .getTikTokWareHouse({
            shopId:this.dataParams.shopId,
            userId:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
        
        this.tiktopStore=res.data.warehouses
        this.tiktopStore.forEach(p => {
            p.checked=false
            if(p.is_default){
                p.checked=true
                this.warehouseId=p.id
            }
        })
        console.log('tiktopStore',this.tiktopStore)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    

    //publishTikTok
    publishTikTok(){
        if(this.falg){
            this.$message.warning(this.$t("other.a324"))
            return
        }
        this.showLoadingbase()
        let prefix="&lt;tag name=&quot;img&quot;&gt;&lt;img src=&quot;"
        let suffix="&quot;&gt;&lt;/img&gt;&lt;/tag&gt;"
        let modelData=JSON.parse(JSON.stringify(this.modelData))
        let that=this
        let description=''
        modelData.imageArray=[]
        let imageList=[]
        modelData.images.forEach(p => {
            description += prefix+p.image+suffix
            modelData.imageArray.push(p.image)
            let image=''
            let num=p.image.indexOf('?x-oss-process=style') 
            if(num !== -1){
                image=p.image.slice(0,num)
            }else{
                image=p.image
            }

            imageList.push(
                this.getTiktokImg({
                    shopId:this.dataParams.shopId,
                    url:image,
                    userId:this.userId,
                    imgScene:1,
                })
            )
        })

        let desc=modelData.description.split('\n')
        let desctText=desc.reduce((cur,next) => {
            return cur+='<p>' + next + '</p>'
        },'')


        console.log('desc',desc);
        console.log('desctText',desctText);
        modelData.isCodOpen=false
        modelData.isPreOrder=false
        modelData.description=desctText
        modelData.platform='TIKTOK'
        modelData.condition='NEW'
        modelData.country='VN'
        modelData.categoryId=this.dataParams.categoryId[this.dataParams.categoryId.length-1]
        modelData.brandId=0
        modelData.productShops=[{
            shopId:this.dataParams.shopId,
            productId:modelData.productId
        }]

       

        Promise.all(imageList).then(res => {
            
            modelData.imageArray=res

            let skuImgList=[]
            modelData.variations.forEach(p => {
                let image=''
                let num=p.image ? p.image.indexOf('?x-oss-process=style') : null
                if(num && num !== -1){
                    image=p.image.slice(0,num)
                }else{
                    image=p.image
                }
                
                skuImgList.push(
                    this.getTiktokImg({
                        shopId:this.dataParams.shopId,
                        url:image,
                        userId:this.userId,
                        imgScene:1,
                    })
                )
            })

            Promise.all(skuImgList).then(respone => {
                 modelData.skus=modelData.variations.map((p,index) => {
                     let params=[]
                     if(that.tiktokAttributeList.length > 1){
                         params=[{
                            attributeId:that.tiktokAttribute[0].id,
                            customValue:p.variationSku,
                            skuImg:respone[index]
                        },{
                            attributeId:that.tiktokAttribute[1].id,
                            customValue:p.value,
                        },]

                     }else{
                         params=[{
                            attributeId:that.tiktokAttribute[0].id,
                            customValue:p.variationSku,
                            skuImg:respone[index]
                        },]
                     }

                    return{
                        originalPrice:p.retailPrice,
                        sellerSku:p.variationSku,
                        salesAttributes:params,
                        stockInfos:[{
                            availableStock:p.stock,
                            warehouseId:this.warehouseId
                        }]
                    }
                })

                tiktokApi
                .publishTiktok(modelData)
                .then(res => {
                if(res.code === 200 ){
                that.hideLoadingbase()
                console.log('desc',res.data)
                let respone=res.data[this.dataParams.shopId]
                if(respone.code == 0){
                    this.$message.success(this.$t("other.a326"))
                }else{
                    this.$message.warning(respone.message)
                }
                console.log('respone',respone)
                }else{
                this.$message.warning(res.msg)
                }
                })

                

            })

            
        })
        
        

        

        
    },
    //发布产品
    publishShopee(){
        this.modelData.country=this.dataParams.country
        this.modelData.categoryId=this.dataParams.categoryId[this.dataParams.categoryId.length-1]
        this.modelData.itemSku=utils.randomString(12)
        
     
        this.checkImgDatas().then(res => {
                if (res == 200) {
        this.checkImgData().then(res => {
            if(res == 200){
                let that=this
                that.handleTire()
                this.modelData.attributes=that.handleAttribute()//处理上传的属性
                this.modelData.logistics=that.handleLogistics()//处理上传的物流
                this.modelData.productShops=[{
                    shopId:this.dataParams.shopId
                }]
                this.modelData.variations.forEach((p,index) => {
                    that.modelData.tiers[0].images[index]=p.image
                    p.tierIndex=[index]
                    p.price=p.retailPrice
                })
                let skuImages=this.modelData.tiers[0].images
                if(Array.isArray(skuImages)){
                    console.log('00')
                    for(let i=0;i<skuImages.length;i++){
                        if(skuImages[i] == null || skuImages[i] == undefined)
                        skuImages[i]=''
                    }
                    console.log('skuImages',skuImages);
                }

                console.log('modelData',this.modelData)
                
               

                that.updataModelData().then((res) => {
                    if(res == 200){
                        let type=-1
                        this.modelData.variations.forEach(p => {
                            
                            if(p.retailPrice == null || p.retailPrice == ''){
                                type=1
                            }
                            if(!p.cusCode){
                                type=2
                            }
                            if(!p.variationSku){
                                type=3
                            }
                        })
                        if(type == 1){
                            this.$message.warning(this.$t("other.a327"))
                            return
                        }
                        if(type == 2){
                            this.$message.warning(this.$t("other.a328"))
                            return
                        }
                        if(type == 3){
                            this.$message.warning(this.$t("other.a329"))
                            return
                        }

                        if(!this.modelData.packageHeight || !this.modelData.packageLength ||!this.modelData.packageWidth){
                            this.$message.warning(this.$t("other.a330"))
                            return
                        }

                        this.showLoadingbase()
                        that.publisModel()
                    }
                })

                console.log('modelData1111',this.modelData);
                
            }
        })
    }
    })
        
    },
    handleTire(){
        this.modelData.tiers[0].images=[]
        this.modelData.tiers[0].optionArray=[]//sku名称 

        this.modelData.variations.forEach(p => {
            this.modelData.tiers[0].images.push(p.image)
            this.modelData.tiers[0].optionArray.push(p.variationSku)
        })

        this.modelData.tiers[0].options=JSON.stringify(this.modelData.tiers[0].optionArray)
        this.modelData.tiers[0].imagesUrl=JSON.stringify(this.modelData.tiers[0].images)
            
    },
    //处理产品属性/shopee
    handleAttribute(){
        let list=[]
        this.shopeeAttribute.forEach(p => {
            if(p.value){
                list.push({
                    attributeId: p.attribute_id,
                    attributeName: p.attribute_name,
                    attributeType: null,
                    attributeValue: p.value ? p.value : null,
                    isMandatory: p.is_mandatory,
                    itemId: null,
                })
            }
        })
        return list
    },
    //处理物流属性/shopee
    handleLogistics(){
        let list=[]
        this.logistics.forEach(p => {
            if(p.checked){
                list.push({
                    enabled: p.enabled,
                    estimatedShippingFee: null,
                    isFree: null,
                    itemId: null,
                    logisticId: p.logistics_channel_id,
                    logisticName: p.logistics_channel_name,
                    productId: null,
                    shippingFee: null,
                })
            }
        })
        return list
    },
        //SHANG图片转换
        checkImgDatas() {
            return new Promise((resolve) => {
                let falg = false
                let that = this
                let arrIndexs = []
                let lists = []
                this.modelData.images.forEach((k, index) => {
                        if (k.image) {
                            if (k.image !== null && k.image.indexOf('shopsbu') > -1) {
                                arrIndexs.push(index)
                                lists.push(this.uploadImg(k.image, this.dataParams.shopId))
                            }
                        }
                    })
                    
                if (arrIndexs.length > 0) {
                    Promise.all(lists).then(res => {
                        console.log('转换后的图片', res);
                        console.log('图片对应索引', arrIndexs);
                        arrIndexs.forEach((k, index) => {
                            this.modelData.images[k].image = res[index].image
                            this.modelData.images[k].imageId = res[index].image_id
                        })
                        resolve(200)
                    })
                }else {
                    resolve(200)
                }



            })
        },
    //图片转换
    checkImgData(){
        return new Promise((resolve) => {
            let falg=false
            let that=this
            let arrIndex=[]
            let list=[]
            this.modelData.variations.forEach((k,index) => {
                if(k.image){
                    if(k.image !== null  && k.image.indexOf('shopsbu') > -1){
                        falg=true
                        arrIndex.push(index)
                        list.push(that.uploadImg(k.image,that.dataParams.shopId))
                    }
                }
            })
            if(arrIndex.length > 0){
                Promise.all(list).then(res => {
                    console.log('转换后的图片',res);
                    console.log('图片对应索引',arrIndex);
                    arrIndex.forEach((k,index) => {
                            this.modelData.variations[k].image = res[index].image
                            this.modelData.variations[k].imageId = res[index].image_id
                    })
                    this.updataModelData()
                    
                    resolve(200)
                    
                })
            }else{
                resolve(200)
            }
        
            
            
        })
    },

   

    addNewFormula(){
        let num=this.formulaList.length+1
        this.formulaList.unshift({
            id:num,
            country:this.dataParams.country,
            dropshippingFee:0,
            outboundfee:0,
            rate:0,
            profit:0,
            discount:0,
            checked:true
        })
    },
    /**c获取用户设置的零售价公式,
    *参数：fornula+PH,userId,
    */
    getUserFormula(){
        let ttp=null
        utils.getInfoByCache({
            cacheKey:'formula'+this.dataParams.country,
            userId:this.userId,
        }).then(res => {
            console.log('9999',res);
            if(res !== null){
                this.formulaList=res
                this.formulaList.forEach(p => {
                    p.discount=p.discount ? p.discount : 0
                })
                console.log('计算公式',this.formulaList)
                if(this.formulaList && this.formulaList.length){
                    this.valuation=this.formulaList.find(item => item.default)
                }else{
                    this.valuation=null
                }
                
            }else{
                this.formulaList=[]
                this.valuation=null
            }
           
        })
    },

    setDefault(item,index){
        if(item.default){
            item.default=false
        }else{

            this.formulaList.forEach(p => {
                p.default=false
            })
    
            item.default=true
        }
        this.itemkey++
        utils.updateInfoByCache({
            cacheKey:'formula'+this.dataParams.country,
            userId:this.userId,
            cacheData:JSON.stringify(this.formulaList)
        }).then(res => {
           
            console.log('ttp',res)
            this.getUserFormula()
        })

        console.log(this.formulaList)
    },

    updateRule(item,index,num){
        console.log(item,index)
        this.variation=null
        if(num == 0){
            this.formulaList.splice(index,1)
             
        }
        item.checked=false
        utils.updateInfoByCache({
            cacheKey:'formula'+this.dataParams.country,
            userId:this.userId,
            cacheData:JSON.stringify(this.formulaList)
        }).then(res => {
            
           this.getUserFormula()
           console.log('ttp',this.valuation)
        })
    },
    
    //shopee上传图片：参数：店铺ID，图片地址
    uploadImg(url,shopId){
        return new Promise((resolve) => {
            api
            .uploadShopeeByImgUrl({
                shopId:shopId,
                url:url
            })
            .then(res => {
                if(res.code === 200 ){  
                            let data = {}
                            data.image = res.data.image_info_list[0].image_info.image_url_list[0].image_url
                            data.image_id = res.data.image_info_list[0].image_info.image_id
                            resolve(data)
                }else{
                this.$message.warning(res.msg)
                }
            })
        })
    },
    //更新模版信息
    updataModelData(){

        return new Promise((resolve) => {
            let params=JSON.parse(JSON.stringify(this.modelData))
            params.modelId=this.$route.query.productId
            params.productId=null
            console.log('params',params);
            api
            .updataProduct(params)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.modelData.productId=res.data.productId
            resolve(200)
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },
    //发布模版信息
    publisModel(){
        api
        .publishProducts({
            productId:this.modelData.productId,
            userId:this.userId
        })
        .then(res => {
            this.hideLoadingbase()
        if(res.code === 200 ){
        console.log('发布模版信息',res.data)
        let text=SHOPEE_PUBLISH_WARNING[res.data[0].msg]
        console.log('text',text);
        if(!text){
            this.$message.success(res.data[0].msg)
        }else{
            this.$message.warning(text)
        }
        }else{
        this.$message.warning(res.msg)
        }
        })
        
    },



    publish(){
        let prefix="&lt;tag name=&quot;img&quot;&gt;&lt;img src=&quot;"
        let suffix="&quot;&gt;&lt;/img&gt;&lt;/tag&gt;"
        let description=''
        this.modelData.images.forEach(p => {
            description += prefix+p.image+suffix
        })
        
        this.modelData.platform='LAZADA'
        this.modelData.country=this.dataParams.country
        this.modelData.categoryId=this.dataParams.categoryId[this.dataParams.categoryId.length-1]
        this.modelData.productShops=[{
            shopId:this.dataParams.shopId,
            productId:this.modelData.productId
        }]


        this.modelData.attributeLazadaList=this.normal.map(p => {
            if(p.name == 'description'){
                p.value=description
            }

            // if(p.name == 'short_description'){
            //     p.value='testc'
            // }


            return {
                attributeId:p.id,
                attributeLazada:p,
                attributeValue:p.value,
                productId:this.modelData.productId
            }
        })
        

        this.modelData.productTierLazadaList=this.modelData.variations.map(p => {
            
            p.price=Number(p.price)
            p.productTierAttributes=[]
            p.images=[p.image]

            this.isSaleProp.forEach(i => {
                p.productTierAttributes.push({
                        attributeId:i.id,
                        attributeValue:p.variationSku,
                        tierId:null,
                        attributeLazada:i
                })
            })

            
            this.skuList.forEach(k => {
                let ttp=null
                if(k.label == 'Price'){
                    ttp=p.price
                }
                if(k.label == "SellerSKU"){
                    ttp=p.variationSku
                }

                if(k.label == "Bundle Size" && k.name == "quantity"){
                    ttp=p.stock
                }

                if(k.label == "Package Weight (kg)"){
                    ttp=this.modelData.weight
                }

                if(k.label == "Package Width (cm)"){
                    ttp=this.modelData.packageWidth
                }

                if(k.label == "Package Length (cm)"){
                    ttp=this.modelData.packageLength
                }

                if(k.label == "Package Height (cm)"){
                    ttp=this.modelData.packageHeight
                }

                p.productTierAttributes.push({
                    attributeId:k.id,
                    attributeValue:ttp,
                    tierId:null,
                    attributeLazada:k
                })
            })
            return p
        })

        

        console.log('modelData',this.modelData)
        console.log('normal',this.normal)
        console.log('skuList',this.skuList)

        
        for(let i = 0;i<this.modelData.attributeLazadaList.length;i++){
                    if(this.modelData.attributeLazadaList[i].attributeLazada.name=='short_description'){
                        this.modelData.attributeLazadaList[i].attributeLazada.value = this.modelData.description
                        this.modelData.attributeLazadaList[i].attributeValue = this.modelData.description
                    }
                    if(this.modelData.attributeLazadaList[i].attributeLazada.name=='name'){
                        this.modelData.attributeLazadaList[i].attributeLazada.value = this.modelData.name
                        this.modelData.attributeLazadaList[i].attributeValue = this.modelData.name
                    }
                }
            // for(let i = 0;i<this.modelData.productTierLazadaList.length;i++){
            //     for(let j = 0;j<this.modelData.productTierLazadaList[i].productTierAttributes.length;j++){
            //             if(this.modelData.productTierLazadaList[i].productTierAttributes[j].attributeLazada.name == 'color_family'){
            //                 this.modelData.productTierLazadaList[i].productTierAttributes.splice(j,1)
            //                 j--;
            //             }
            //         }
            //     }
        this.showLoading()
        lazadaordersApi
        .publishLazada(this.modelData)
        .then(res => {
        this.hideLoading()
        if(res.code === 200 ){
            
        console.log('desc',res.data)
        if(res.data[0].code == '0'){
            this.$message.success(WARNING_CODES[res.data[0].code])
        }else{
            this.$message.warning(WARNING_CODES[res.data[0].code])
        }
        
        
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    //获取模版信息
    getModelInfo(){
        api
        .getProductByproductId({
            productId:this.$route.query.productId
        }).then(res => {
            if(res.code == 200){
                console.log('模版数据',res.data)
                let that=this
                let list=res.data
                this.falg=false
                list.drag=false
                list.variations.forEach(p => {
                    let ttp=this.groupInfo.storeItems.find(item => item.cusCode == p.cusCode)
                    // that.falg= ttp ? false :true
                    console.log('ttp',ttp);
                    p.imageId = ttp ?ttp.imageId:null
                    // p.price=ttp ? ttp.children[0].price.toFixed(2) :p.price
                    p.retailPrice=null
                    p.supplyPrice=p.price
                    // p.stock=ttp ? ttp.stock : p.stock
                    p.image=list.tiers[0].images[p.tierIndex[0]]
                })
                if(that.falg){
                    this.$message.warning(this.$t("other.a324"))
                }
                this.modelData=res.data
                console.log('009',this.modelData);
                if(this.publishType == 'shopee'){

                    this.getLoagistics({shopId:this.dataParams.shopId,categoryId:this.dataParams.categoryId[this.dataParams.categoryId.length-1]})
                }else if(this.publishType == 'lazada'){
                    this.getAttributeById()
                }else if(this.publishType == 'TikTok Shop'){
                    this.getTikTokAttribute()
                    this.getTikTokAttributeRule()
                    this.getTikTokBrand()
                    this.getTiktokWarehouse()
                }

                this.getUserFormula()
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    //获取tiktok的品牌
    getTikTokBrand(){
        tiktokApi
        .getTikTokBrand({
            userId:this.userId,
            shopId:this.dataParams.shopId
        })
        .then(res => {
        if(res.code === 200 ){
       
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    //获取tiktok的产品属性
    getTikTokAttribute(){
        tiktokApi
        .getTikTokAttribute({
            categoryId:this.categoryId[this.categoryId.length-1],
            userId:this.userId,
            shopId:this.dataParams.shopId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('tiktokAttribute',res.data.attributes)
        this.tiktokAttribute=res.data.attributes
        this.tiktokAttributeList=res.data.attributes.filter(p => {
            if(p.input_type.is_mandatory){
                return {
                    name:p.name,
                    type:'tiktok'
                }
            }
        })
        console.log('tiktokAttributeList',this.tiktokAttributeList);
        }else{
        this.$message.warning(res.msg)
        }
        })

    },

    //获取tiktok的产品属性
    getTikTokAttributeRule(){
        tiktokApi
        .getTikTokCategoryRule({
            categoryId:this.categoryId[this.categoryId.length-1],
            userId:this.userId,
            shopId:this.dataParams.shopId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('规则',res.data.attributes)
        
        }else{
        this.$message.warning(res.msg)
        }
        })

    },

    //获取lazada产品的类目属性
    getAttributeById(id){
        lazadaordersApi
        .getLazadaAttribution({
            categoryId:this.categoryId[this.categoryId.length-1],
            userId:this.userId,
            shopId:this.dataParams.shopId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)

        this.normal=res.data.normal.filter(p => {
            p.value=null
            if(p.name == 'brand'){
                p.options=[{
                    name:'No Brand',
                    id:0
                }]
            }
            if(p.name == 'name' || p.label =='Name'){
                p.value=this.modelData.name
            }

            if(p.kdfk !== 'inputType')
            
            return p
            
        })

        //必需要传的sku销售属性

        this.isSaleProp=[]
        this.skuList=[]
        
        res.data.sku.forEach(p => {
            if(p.isMandatory){
                this.skuList.push(p)
            }
            if(p.name == 'quantity' || p.label == 'Images'){
                this.skuList.push(p)
            }

            if(p.isSaleProp){
                this.isSaleProp.push(p)
            }
        })

        console.log('normal',this.normal)
        console.log('skuList',this.skuList)
        console.log('isSaleProp',this.isSaleProp)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    deleteItem(index){
        this.modelData.variations.splice(index,1)
    },

    massSetVariation(){
        this.modelData.variations.forEach((p,index) => {
            p.variationSku=this.sellerSKU ? this.sellerSKU : p.variationSku
            p.retailPrice=this.priceValue ? this.priceValue : p.retailPrice
            p.price=this.priceValue ? this.priceValue : p.price
            p.stock=this.stock ? this.stock : p.stock

            this.$set(this.modelData.variations,index,p)
        })
    },

    handleExceed(files, fileList) {
        this.$message.warning(this.$t("other.a331"));
    },

    handlePreview(file) {
        console.log(file);
        this.modelData.images.push({
            image: file.data,
            itemId: null,
            positions: null,
            productId: this.modelData.productId
        })
    },

    changePic(item,index){
        this.changeAttrPic=true
        console.log(item,index)
        this.updatPic=true
        this.changePicObj=item.tierIndex[0]  
    },

    handleUploadHttpRequest(params){
        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2

        let formData=new FormData()
        formData.append('file',_file)
            if (JSON.parse(localStorage.getItem('userInfo')).shopeeShops) {
        formData.append('shopId',JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
        formData.append('isUploadToShopee',true)
            }

        if(!isLt2M){
            this.$message.error(this.$t("other.a332"));
            return false;
        }

        console.log('formData',formData)

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                        let IMGID = null
                        if (JSON.parse(localStorage.getItem('userInfo')).shopeeShops) {
                            this.imageUrl = res.data.image_info_list[0].image_info.image_url_list[0].image_url
                            this.imageId = res.data.image_info_list[0].image_info.image_id
                            IMGID = res.data.image_info_list[0].image_info.image_id
                        } else {
                            this.imageUrl = res.data
                        }
                if(!this.changeAttrPic){

                    let num=this.ruleForm.images.length+1
                    this.ruleForm.images.push({
                        image:this.imageUrl,
                        positions:num,
                        productId:null,
                        itemId:null,
                                imageId: IMGID
                    })
    
                    console.log(this.ruleForm)
                }

            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    beforeAvatarUpload(file) {
        console.log('files',file)
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            this.$message.error(this.$t("other.a333"));
        }
        return  isLt2M;
    },

    imgConfirm(){
        console.log(this.changePicObj)
        console.log(this.imageUrl)
        console.log(this.ruleForm)
        let ttp=this.modelData.variations[this.changePicObj]
        ttp.image= this.imageUrl
        ttp.imageId = this.imageId
        this.$set(this.modelData.variations,this.changePicObj,ttp)
        this.updatPic=false
        this.changeAttrPic=false
        
    },
    loadMore(){
        return () => this.rangeNumber += 5
    },
    //获取shopee产品的类目属性
    getLoagistics(params){
        this.showLoadingbase()
        api
        .getShopLogisticsAndAttribute(params)
        .then(res => {
            if(res.code === 200) {
                console.log('090',res.data);
                this.shopeeAttribute=res.data.attributes
                this.shopeeAttribute.forEach(p => {
                    if(p.attribute_id == 0){
                        let list=[]
                        let newObj={}
                        p.values.forEach(i => {
                            if(!newObj[i.original_value]){
                                newObj[i.original_value]=i.original_value
                                list.push(i)
                            }
                        })
                        p.values=list

                        console.log('list',list);

                    }
                })

                this.shopeeAttribute.sort((a,b) => {
                    return a.attribute_name.charCodeAt(0)-b.attribute_name.charCodeAt(0)
                })


                this.logistics=[]
                res.data.logistics.forEach(p => {
                    if(p.enabled){
                        p.checked=false
                        if(p.logistics_channel_id == 4000 || p.logistics_channel_id==2000){
                            p.checked=true
                        }
                        this.logistics.push(p)
                    }
                })

                this.hideLoadingbase()
                
                
            
                
            }else{
                this.$message.warning(res.msg)
            }
        })
        

        
    },

    randomNum(){
        let arr=JSON.parse(JSON.stringify(this.modelData.images))
            for(var i=0,len=arr.length;i<len;i++){
                    var a=parseInt(Math.random()*len);
                    var temp=arr[a];
                    arr[a]=arr[i];
                    arr[i]=temp;
            }
            for(var i=0,len=arr.length;i<len;i++){
                    arr[i].positions=i;
                    arr[i].label="image"+ i;
            }
            this.modelData.images=arr
    },
    logImg(){
        console.log('999',this.modelData);
        let list=this.modelData.images
        for(let i=0;i<list.length;i++){
            list[i].positions=i
        }
        console.log('list',list);
    },

    editorwaterMakr(){
        let image=JSON.stringify(this.modelData.images)
        localStorage.setItem('warterImg',image)
        this.$router.push({
            path:'/watermark',
            query:{
                productId:this.$route.query.productId,
                groupId:this.$route.query.groupId,
                type:this.$route.query.type,
                shopId:this.dataParams.shopId
            }
        })
    },

    editorImg(url,index){
        console.log(url,index);
        let params={
            url,
            index,
        }
        localStorage.setItem('editorImg',JSON.stringify(params))
        this.$router.push({
            path:'/imageEdit',
            query:{
                productId:this.$route.query.productId,
                groupId:this.$route.query.groupId,
                type:this.$route.query.type,
                shopId:this.dataParams.shopId
            }
        })

    },

   

    //删除sku相同字符
    massDelSamefont(){
        if(this.fontValue == null){
            return
        }
        let text=this.fontValue
        let reg=new RegExp(text, 'g');//g 全局匹配
        this.modelData.variations.forEach(p => {
            p.variationSku=p.variationSku.replace(reg,"")
        })
        this.fontValue=null

        console.log('0099',this.modelData);
    },
}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.addGoodsWrapper{
    margin-top: $top_header_height;
    position: relative;

    /deep/ .el-dialog__body{
        padding: 4px 20px;

        .tips{
        color: red;
        margin-bottom: 2px;
        font-size: 15px;
    }
    }

    

    .footer{
        position: fixed;
        text-align: center;
        left: 0;
        right: 0;
        bottom: 0;
        padding:  15px 0;
        height: 40px;
        background-color: #eee;
        z-index: 99;
    }

    .avatar {
    width: 178px;
    height: 178px;
    display: block;
    }


    .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
    }
    .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;

    border: 1px solid #000;
    border-radius: 5px;
    }

    .center{
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 1248px;
        font-size: 12px;
        height: calc(100vh - 50px);


        .iyubn{
            position: relative;

            .ingknv{
                position: absolute;
                top: 5px;
                right: 10px;
                font-size: 12px;
            }
        }

        .ImgPox{
            width: 40px;
            height: 40px;
            overflow: hidden;
            border-radius: 2px;
            border: 1px dashed #eee;
            cursor: pointer;

            img{
                width: 100%;
            }
        }

        .attImg{
            width: 40px;
            height: 40px;
            overflow: hidden;
            border-radius: 2px;
            border: 1px dashed #eee;
            cursor: pointer;
        }

        .attImg::before{
            content: '+';
            position: relative;
            top: 7px;
            left: 12px;
            font-size: 20px;
            color: #eee;


        }



        .ikrn::before{
            margin-right: 4px;
            content: "*";
            color: #e64a4a;
        }

        .baseInfo{
            border: 1px solid #eee;
            margin-top: 20px;

            .bugkn{
                display: flex;
                justify-content: space-between;
                padding: 0 10px 10px 116px;
                font-size: 16px;
                color: #757575;
                font-weight: 600;
            }

            .title{
                font-size: 18px;
                color: rgba(0,0,0,0.8);
                padding: 17px 15px;
                font-weight: bold;
            }

            .supplice{
                position: absolute;
                top: 12.5px;
                right: 11px;
            }


            .gong{
                background-color: #f5f5f5;
                padding: 1px 5px;
                display: inline-block;
                width: 78px;
            }

            .refd{
                padding: 15px 0;
            }

            .yhjv{
                margin: 10px;
                background-color: #fff;
                box-sizing: border-box;
                padding: 5px 10px;

                .gtyh{
                    padding-bottom: 10px;
                    border-bottom: 1px solid #eee;
                }

                .ppolk{
                    display: flex;
                    margin-top: 10px;
                }
            }
            

            .leftTesc{
                display: flex;
                font-size: 16px;
                color: rgba(0,0,0,0.8);
                padding-left: 20px;
                margin-bottom: 40px;

                .tgrf{
                    padding: 5px 15px;
                }

                .qbrt{
                    padding: 6px 15px;

                    input{
                        border: none;
                    }
                }

                .ppol{
                    background-color: #f7f8fa;
                }

                .bghd{
                    font-size: 14px;
                    padding: 2px 5px;
                }

                .ilnrg{
                    display: flex;
                    flex-wrap: wrap;
                    width: 973px;
                    justify-content: space-between;

                    .ijgn{
                        font-size: 14px;
                        padding-bottom: 5px;

                    }


                    .yhgt{
                        display: flex;
                        margin-top: 10px;
                        box-sizing: border-box;
                        padding: 2px 15px;

                        .yjbg{
                            margin-right: 93px;
                        }
                    }

                    .kong{
                        border: 1px solid #eee;
                        display: inline-block;
                        width: 80px;
                    }

                    .ogong{
                        width: 255px;
                        margin-bottom: 8px;

                        .olik{
                            font-size: 12px;
                            margin-bottom: 2px;
                        }

                        
                    }
                }


                .inrk{
                    padding-right: 20px;
                }

                .imgBox{
                    width: 96px;
                    height: 96px;
                    border: 1px dashed #dbdbdb;
                    position: relative;
                    top: 21px;
                    left: 10px;
                    margin:1px 1px;
                    cursor: pointer;
                    overflow: hidden;
                    position: relative;

                    .pomjg{
                        text-align: center;
                        margin-top: 30px;
                    }

                    .delBox{
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        text-align: center;
                        background-color: rgba(0,0,0,0.5);
                        color: #fff;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;

                        .ingk{
                            display: flex;
                            justify-content: space-around;
                            padding-bottom: 10px;

                            .el-icon-edit{
                                padding: 0 5px;
                            }

                        }
                    }
                }


            }
        }

        .mainContent{
            display: flex;
        }

        .lefttips{
            width: 150px;
            box-sizing: border-box;
            padding: 5px;


            .sigk{
                margin-top: 250px;
                box-sizing: border-box;
                padding: 10px 10px;
                box-shadow: 0 0 8px 0 #f3f3f3;
                position: fixed;
                width: 139px;

                .jgind{
                    background-color: #ff7300;
                    text-align: center;
                    padding: 5px 0; 
                    color: #fff;

                    
                }

                .kloi{
                        padding: 2px 0;
                    }
            }
        }

        .right_content{
            flex: 1;
            margin-bottom: 150px;
        }

        .desctext{
            font-size: 20px;
            color: #757575;
            padding: 10px 0;
        }

        .categoryDesc{
            background-color: #f7f8fa;
            margin-top: 20px;
            padding: 10px ;
        }

        .categoryname{
            margin:0  5px;

            .inkg{
                padding: 0 5px;
            }
        }
    }

    /deep/ .el-upload-list{
        display: none;
    }
}
</style>